import React from "react";
import { FaFacebook } from "react-icons/fa";
import "./SocialCards.css";

const FacebookCard = ({ cover, followers, link, profileImg }) => {
  return (
    <div className="facebook-card">
      <img src={cover} alt="cover" className="fb-cover-full" />
      <div className="fb-overlay">
        <div className="fb-header">
          <div className="fb-logo-circle">
            <img src={profileImg} alt="Facebook Profile" className="fb-profile-img" />
          </div>
          <div className="fb-info">
            <h4 className="fb-username">All Home Desire</h4>
            <p className="fb-followers">{followers} followers</p>
          </div>
        </div>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="fb-visit-btn"
        >
          Visit Facebook
        </a>
      </div>
    </div>
  );
};

export default FacebookCard;
